import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-intro-video-modal',
  templateUrl: './intro-video-modal.component.html',
  styleUrls: ['./intro-video-modal.component.scss']
})
export class IntroVideoModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IntroVideoModalComponent>) { }

  ngOnInit(): void {
  }

  onVideoEnded() {
    this.dialogRef.close()
    localStorage.setItem('newVisitorIntroduction', 'false')
  }


}
